import { STORAGE_KEYS } from "constants/index";
import { appLocalStorage } from "utils/storage";

type AccountTypeCache = Record<string, boolean>;

function readCache(): AccountTypeCache {
  return appLocalStorage.get<AccountTypeCache>(STORAGE_KEYS.ACCOUNT_TYPE) ?? {};
}

export function getCachedIndividualAccount(
  companyId: string | number | null | undefined
): boolean | undefined {
  if (companyId == null || companyId === "") return undefined;
  const entry = readCache()[String(companyId)];
  return typeof entry === "boolean" ? entry : undefined;
}

export function setCachedIndividualAccount(
  companyId: string | number,
  isIndividual: boolean
): void {
  const cache = readCache();
  cache[String(companyId)] = isIndividual;
  appLocalStorage.set(STORAGE_KEYS.ACCOUNT_TYPE, cache);
}

export function clearAccountTypeCache(): void {
  appLocalStorage.remove(STORAGE_KEYS.ACCOUNT_TYPE);
}
